export default {
  firstLabel: {
    en: 'You entered:',
  },
  secondLabel: {
    en: 'We recommend:',
  },
  buttonUseTitle: {
    en: 'Use this address',
  },
  buttonEditTitle: {
    en: 'Edit this address',
  },
  sharedLabel: {
    en: 'Select address option',
  },
}
